// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IRequestWithHeader, Types } from './types';

export function enderecoIpRequest(
	token: string,
	payload: IRequestWithHeader,
): ReducerActionRotaSP {
	return {
		type: Types.ENDERECO_IP_REQUEST,
		token,
		payload,
	};
}
export function enderecoIpSuccess(
	payload: IRequestWithHeader,
): ReducerActionRotaSP {
	return {
		type: Types.ENDERECO_IP_SUCCESS,
		payload,
	};
}
export function enderecoIpFailure(): ReducerActionRotaSP {
	return {
		type: Types.ENDERECO_IP_FAILURE,
		payload: null,
	};
}
export function enderecoIpClear(): ReducerActionRotaSP {
	return {
		type: Types.ENDERECO_IP_CLEAR,
		payload: null,
	};
}
